import React, { useState, useEffect, useContext } from 'react'
import { Formik, Form } from 'formik'
import { FiPlus, FiTrash } from 'react-icons/fi'

import { Button, File, Select, Textbox } from '../Form'

import { api, authHeaders } from '../../services/api'

import formUtils from '../../util/form'

import { Container } from './styles'
import { toast } from 'react-toastify'
import { GlobalContext } from '../../contexts/GlobalContext'
import Yup from '../../services/yup'

const baseInitialValues = {
    grau: '',
    formacao: '',
    instituicao: '',
    certificado: null
}

const validation = Yup.object({
    grau: Yup.string().required('Informe o grau.'),
    instituicao: Yup.string().required('Informe a instituição.'),
    certificado: Yup.string().required('Anexe o certificado.').nullable()
})

export default function ({
    reload, style, formacaoInitialValues, editId, pessoa, ...rest
}) {
    const { checkException } = useContext(GlobalContext)

    const [initialValues, setInitialValues] = useState(baseInitialValues)
    const [formacoes, setFormacoes] = useState([])
    const [graus, setGraus] = useState([])
    const [faculdades, setFaculdades] = useState([])
    const [formacoesSelecionadas, setFormacoesSelecionadas] = useState(formacaoInitialValues?.formacao || [])

    const [mostrarCadastroNovaInstituicao, setMostrarCadastroNovaInstituicao] = useState(editId ? formacaoInitialValues?.nova_instituicao_nome : false)

    async function loadFaculdades() {
        const faculdades = await api.get('faculdade')

        setFaculdades(faculdades)
    }

    async function loadGraus() {
        const response = await api.get('grau_formacao')

        setGraus(response)
    }

    async function loadFormacoes(paiId = null) {
        try {
            const data = await api.get('formacao', {
                params: {
                    pai_id: paiId || null
                }
            })

            setFormacoes(data)
        } catch (e) {
            toast.error(e.msg)
        }
    }

    function handleRemoverFormacao(id) {
        const posicao = formacoesSelecionadas.findIndex(i => i.value === id)

        setFormacoesSelecionadas(old => old.slice(0, posicao))
    }

    useEffect(() => {

        setInitialValues(formacaoInitialValues || baseInitialValues)
    }, [initialValues])

    useEffect(() => {
        loadFaculdades()

        loadGraus()

        loadFormacoes()
    }, [])

    useEffect(() => {
        if (formacoesSelecionadas) {
            const ultimaFormacaoId = formacoesSelecionadas.at(-1)

            loadFormacoes(ultimaFormacaoId?.value || null)
        }

        setTimeout(() => {
            document.querySelector('.formacao-field > div > div > div:first-child').innerHTML = ''
        }, 100)
    }, [formacoesSelecionadas])

    async function onSelectInstituicao(instituicaoId, setFieldValue) {
        setMostrarCadastroNovaInstituicao(instituicaoId === 9999)

        if (instituicaoId !== 9999) {
            setFieldValue('nova_instituicao_nome', '')
            setFieldValue('nova_instituicao_uf_cidade', '')
        }
    }

    async function adicionar(values, { setSubmitting, resetForm }) {
        try {
            const data = formUtils.extractFormValues(values)

            await api.post('pessoa_formacao', {
                pessoa_id: pessoa.id,
                ...data,
                formacao: formacoesSelecionadas.map(i => i.value)
            }, authHeaders())

            reload()

            setSubmitting(false)

            resetForm()
        } catch (e) {
            checkException(e)
        }
    }

    async function editar(values, { setSubmitting, resetForm }) {
        try {
            const data = formUtils.extractFormValues(values)

            data.formacao = formacoesSelecionadas.map(i => i.value)

            await api.put(`pessoa_formacao/${editId}`, data, authHeaders())

            reload()

            setSubmitting(false)
            resetForm()
        } catch (e) {
            checkException(e)
        }
    }

    async function handleSubmit(values, formikBag) {
        if (!formacoesSelecionadas.length) {
            toast.error('Selecione a formação.')
            return
        }

        if (values.instituicao.value === 9999 && (!values.nova_instituicao_nome || !values.nova_instituicao_uf_cidade)) {
            toast.error('Informe o nome e local da Instituição de ensino.')
            return
        }


        if (editId) {
            editar(values, formikBag)
        } else {
            adicionar(values, formikBag)
        }
    }

    return (
        <Container style={style} edit-mode={!!editId} {...rest}>
            <Formik
                onSubmit={handleSubmit}
                initialValues={initialValues}
                enableReinitialize
                validationSchema={validation}
            >
                {({ setFieldValue, errors, values }) => (
                    <Form className="grid grid-cols-3 pb-4 items-start">
                        <Select
                            name="grau"
                            label="Grau"
                            onChange={(selected, meta) => { setFieldValue(meta.name, selected) }}
                            options={graus.map(formacao => ({
                                label: formacao.descricao,
                                value: formacao.id
                            }))}
                            isSearchable={false}
                        />

                        <Select
                            name="instituicao"
                            label="Instituição de ensino"
                            onChange={(selected, meta) => {
                                setFieldValue(meta.name, selected)

                                onSelectInstituicao(selected.value, setFieldValue)
                            }}
                            options={faculdades.map(faculdade => ({
                                label: `${faculdade.descricao} ${faculdade.sigla ? `(${faculdade.sigla})` : ''}`,
                                value: faculdade.id
                            }))}
                        />

                        <File
                            name="certificado"
                            label="Anexe o Certificado de Conclusão"
                            onSuccess={fileId => setFieldValue('certificado', fileId)}
                            format="square"
                            error={errors.certificado}
                            style={{ width: 'calc(100% - 16px)' }}
                            previewSize={['100%', '120px']}
                            className="row-span-3"
                            getPreloadImage={async () => {
                                const arquivo = await api.get(`arquivo/${values.certificado}`)
                                return arquivo?.link
                            }}
                        />

                        {mostrarCadastroNovaInstituicao && (
                            <>
                                <Textbox
                                    label="Nome da instituição"
                                    name="nova_instituicao_nome"
                                />

                                <Textbox
                                    label="Estado e cidade da instituição"
                                    name="nova_instituicao_uf_cidade"
                                />
                            </>
                        )}

                        <Select
                            name="formacao"
                            label="Formação"
                            withoutForm
                            className="formacao-field"
                            onChange={selected => {
                                setFormacoesSelecionadas(old => [...old, selected])
                            }}
                            options={formacoes.map(formacao => ({
                                label: formacao.descricao,
                                value: formacao.id
                            }))}
                        />

                        <div className="col-span-2 flex gap-4 w-full px-2 py-3 col-start-1">
                            {formacoesSelecionadas.map(formacaoSelecionada => (
                                <div key={formacaoSelecionada.value} className="flex space-between gap-2 border rounded-md border-white p-2 items-center h-fit">
                                    <span>{formacaoSelecionada.label}</span>

                                    <FiTrash
                                        size={16}
                                        onClick={() => {
                                            handleRemoverFormacao(formacaoSelecionada.value)
                                        }}
                                        className="cursor-pointer hover:text-red-500"
                                    />
                                </div>
                            ))}

                            {!!formacoesSelecionadas.length && !!formacoes.length && (
                                <div className="text-xs w-56 text-gray-300">
                                    Você pode ser mais específico em sua formação, selecionando acima.
                                </div>
                            )}
                        </div>

                        <Button
                            className="transparent w-fit justify-self-end col-start-3"
                            type="submit"
                        >
                            {editId ? 'Salvar alterações' : 'Adicionar'}
                            <FiPlus size={16} />
                        </Button>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
